"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFitText = _interopRequireDefault(require("@plutonium-js/react-fit-text"));

var _toPx = _interopRequireDefault(require("to-px"));

var _Fonts = require("../00_environment/Fonts");

var _Container = _interopRequireDefault(require("./Container"));

var _Colors = require("../00_environment/Colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TitledContainer = function TitledContainer(_ref) {
  var title = _ref.title,
      rightButtonText = _ref.rightButtonText,
      _ref$onRightButtonCli = _ref.onRightButtonClick,
      onRightButtonClick = _ref$onRightButtonCli === void 0 ? function () {} : _ref$onRightButtonCli,
      children = _ref.children,
      backgroundColor = _ref.backgroundColor,
      fontSize = _ref.fontSize,
      _ref$noSidePadding = _ref.noSidePadding,
      noSidePadding = _ref$noSidePadding === void 0 ? false : _ref$noSidePadding,
      _ref$fullHeight = _ref.fullHeight,
      fullHeight = _ref$fullHeight === void 0 ? false : _ref$fullHeight,
      _ref$wrapTitle = _ref.wrapTitle,
      wrapTitle = _ref$wrapTitle === void 0 ? false : _ref$wrapTitle;
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    noSidePadding: noSidePadding,
    style: {
      backgroundColor: backgroundColor || _Colors.paneBackgroundColor,
      minHeight: '100%',
      paddingBottom: 30,
      height: fullHeight ? '100%' : undefined
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: "titled-container-header",
    style: _objectSpread(_objectSpread({}, (0, _Fonts.withPaneTitleFont)({
      marginTop: 15,
      marginBottom: 30,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'baseline',
      paddingLeft: noSidePadding ? 25 : 0,
      // Keep padding on title even with noSidePadding
      paddingRight: noSidePadding ? 25 : 0 // Keep padding on title even with noSidePadding

    })), fontSize ? {
      fontSize: fontSize
    } : {})
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flex: '1',
      overflow: 'hidden'
    }
  }, wrapTitle && /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontSize: fontSize ? (0, _toPx["default"])(fontSize) : 22,
      whiteSpace: 'pre-wrap'
    }
  }, title), !wrapTitle && /*#__PURE__*/_react["default"].createElement(_reactFitText["default"], {
    maxSize: fontSize ? (0, _toPx["default"])(fontSize) : 22
  }, title)), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: onRightButtonClick,
    style: (0, _Fonts.withBoldFont)({
      cursor: 'pointer',
      paddingLeft: 20
    })
  }, rightButtonText)), /*#__PURE__*/_react["default"].createElement("div", null, children));
};

var _default = TitledContainer;
exports["default"] = _default;